import React from "react";
import { Outlet } from "react-router-dom";
import { USERROLEENUM } from "./helper/constant";
import { ManageClientProvider } from "./context/ManageClientContex";
import { ManageProjectProvider } from "./context/ManageProjectContext";
import { ReportTimesheetProvider } from "./context/ReportTimsheetContex";
import { AdminProvider } from "./context/AdminContext";
// ipms
// import IPMSLayout from "./layouts/IPMS";
//import HomePage from "./pages/Ipms/home";
// import EmployeeGoalReviewPage from "./pages/Ipms/employeeGoalsview";
// import GoalsAssessmentPage from "./pages/Ipms/goalsAssessment";
// import GoalPage from "./pages/Ipms/goal";
// import MangageGoalsPage from "./pages/Ipms/manageGoals";
// import CreateUpdateGoalsForm from "./pages/Ipms/createUpdateGoals";
// import { ManageIPMSProvider } from "./context/ManageIPMSContex";
// import EmployeeGoalAssessmentReviewPage from "./pages/Ipms/employeeGoalsAssessmentView";
// import EmployeeFinalGoalAssessmentReviewPage from "./pages/Ipms/employeeFinalGoalsAssessmentView";
// ipms_new (new API)
import IPMSNewLayout from "./layouts/IPMS_NEW";
import NewHomePage from "./pages/ipms_new/home";
import NewEmployeeGoalReviewPage from "./pages/ipms_new/employeeGoalsview";
import NewGoalsAssessmentPage from "./pages/ipms_new/goalsAssessment";
import NewGoalPage from "./pages/ipms_new/goal";
import NewMangageGoalsPage from "./pages/ipms_new/manageGoals";
import NewCreateUpdateGoalsForm from "./pages/ipms_new/createUpdateGoals";
import { ManageIPMSProvider as NewManageIPMSProvider } from "./pages/ipms_new/ManageIPMSContex";
import NewEmployeeGoalAssessmentReviewPage from "./pages/ipms_new/employeeGoalsAssessmentView";
import NewEmployeeFinalGoalAssessmentReviewPage from "./pages/ipms_new/employeeFinalGoalsAssessmentView";
import NewAppriserEmployeeListPage from "./pages/ipms_new/appriserEmployeeList";
import NewAssignManagerForm from "./pages/ipms_new/assignManager";
// iontime
import TimeSheetLayout from "./layouts/ionTime";
import ManageProject from "./pages/IonTime/manage/manageProject";
import CreateProjectPage from "./pages/IonTime/manage/createProject";
import UpdateProjectPage from "./pages/IonTime/manage/updateProject";
import TimesheetPage from "./pages/IonTime/report/timesheet";
import TimesheetReportPage from "./pages/IonTime/report/timesheetReport";
import MyTimesheetReport from "./pages/IonTime/report/myTimesheetReport";
import ApproveRejectList from "./pages/IonTime/report/approveRejectList";
import ReviewApproveTimesheet from "./pages/IonTime/report/reviewApproveTimesheet";
import ManageClient from "./pages/IonTime/admin/manageClient";
import CreateClientPage from "./pages/IonTime/admin/createClient";
import UpdateClientPage from "./pages/IonTime/admin/updateClient";
import ProjectForm from "./pages/IonTime/admin/tabs/forms/ProjectForm";
import AdminLayout from "./layouts/Admin";
import UserPage from "./pages/admin/userPage";
import RolePage from "./pages/admin/rolePage";
import DepartmentPage from "./pages/admin/departmentPage";
import UserForm from "./pages/admin/form/userForm";
import UpdateClientProjectPage from "./pages/IonTime/admin/updateProject";
import TimesheetsReportPage from "./pages/IonTime/report/TimesheetsReport";
import LeaveReportPage from "./pages/IonTime/report/LeaveReportPage";
import DiscrepancyReportPage from "./pages/IonTime/report/DiscrepancyReportPage";
import MomentRegisterReportPage from "./pages/IonTime/report/MomentRegisterReportPage";
import ExportTimesheetsReportPage from "./pages/IonTime/report/exportTimesheetReport";
import FinanceMonthlyReportPage from "./pages/IonTime/report/financeMonthlyReport";
import SkillsManagement from "./pages/IonTime/skills/skills";
// import GuidelineScreen from "./pages/Ipms/guidline";
// import FlowCharts from "./pages/Ipms/flowcharts";
// import AppriserEmployeeListPage from "./pages/Ipms/appriserEmployeeList";
// import AssignManagerForm from "./pages/Ipms/assignManager";
import SkillsReportPage from "./pages/IonTime/report/SkillsReportPage";
// import IPMSReportPage from "./pages/Ipms/IpmsReport";
import GuidelineScreen from "./pages/ipms_new/guidline";
import FlowCharts from "./pages/ipms_new/flowcharts";
import NewIPMSReportPage from "./pages/ipms_new/IpmsReport";
import ProjectTimesheetsPage from "./pages/IonTime/report/ProjectTimesheets";
import EmployeeAssignmentDirectoryReportPage from "./pages/IonTime/report/EmployeeAssignmentDirectoryReportPage";

export interface RouteConfig {
  path: string;
  element: React.ReactNode;
  roles: number[];
  children?: RouteConfig[];
}

// Note: QueryClientProvider moved to application root (`index.tsx`)

export const routesConfig: RouteConfig[] = [
  {
    path: "/admin",
    element: (
      <AdminProvider>
        <AdminLayout />
      </AdminProvider>
    ),
    roles: [USERROLEENUM.ADMIN],
    children: [
      {
        path: "user",
        element: <Outlet />,
        roles: [USERROLEENUM.ADMIN],
        children: [
          {
            path: "",
            element: <UserPage />,
            roles: [USERROLEENUM.ADMIN],
          },
          {
            path: "create",
            element: <UserForm />,
            roles: [USERROLEENUM.ADMIN],
          },
          {
            path: "update",
            element: <UserForm />,
            roles: [USERROLEENUM.ADMIN],
          },
        ],
      },
      {
        path: "role",
        element: <RolePage />,
        roles: [USERROLEENUM.ADMIN],
      },
      {
        path: "department",
        element: <DepartmentPage />,
        roles: [USERROLEENUM.ADMIN],
      },
    ],
  },
  {
    path: "/",
    element: (
      <ReportTimesheetProvider>
        <TimeSheetLayout />
      </ReportTimesheetProvider>
    ),
    roles: [
      USERROLEENUM.ADMIN,
      USERROLEENUM.EMPLOYEE,
      USERROLEENUM.TSApprover,
      USERROLEENUM.FINANCE,
      USERROLEENUM.HR,
      USERROLEENUM.MANAGER,
    ],
    children: [
      {
        path: "manageproject",
        element: (
          <ManageProjectProvider>
            <Outlet />
          </ManageProjectProvider>
        ),
        roles: [USERROLEENUM.MANAGER],
        children: [
          {
            path: "",
            element: <ManageProject />,
            roles: [USERROLEENUM.MANAGER],
          },
          {
            path: "createProject",
            element: <CreateProjectPage />,
            roles: [USERROLEENUM.MANAGER],
          },
          {
            path: "updateProject",
            element: <UpdateProjectPage />,
            roles: [USERROLEENUM.MANAGER],
          },
        ],
      },
      {
        path: "timesheetReport",
        element: <TimesheetReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "projectTimesheetsReport",
        element: <ProjectTimesheetsPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },      
      {
        path: "timesheets",
        element: <TimesheetsReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "skillsreport",
        element: <SkillsReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "exporttimesheets",
        element: <ExportTimesheetsReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "monthlyfinanceReport",
        element: <FinanceMonthlyReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "",
        element: <TimesheetPage />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "mytimesheetreport",
        element: <MyTimesheetReport />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "employeeskills",
        element: <SkillsManagement />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "leaveReports",
        element: <LeaveReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "movementregister",
        element: <MomentRegisterReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "discrepancyReports",
        element: <DiscrepancyReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "employeeAssignmentDirectory",
        element: <EmployeeAssignmentDirectoryReportPage />,
        roles: [USERROLEENUM.HR, USERROLEENUM.ADMIN, USERROLEENUM.FINANCE],
      },
      {
        path: "approveRejectList",
        element: <ApproveRejectList />,
        roles: [
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.ADMIN,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "reviewApproveTimesheet",
        element: <ReviewApproveTimesheet />,
        roles: [
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.ADMIN,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "client",
        element: (
          <ManageClientProvider>
            <Outlet />
          </ManageClientProvider>
        ),
        roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
        children: [
          {
            path: "",
            element: <ManageClient />,
            roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
          },
          {
            path: "createclient",
            element: <CreateClientPage />,
            roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
          },
          {
            path: "updateclient",
            element: <UpdateClientPage />,
            roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
          },
          {
            path: "createclientproject",
            element: <ProjectForm />,
            roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
          },
          {
            path: "updateclientproject",
            element: <UpdateClientProjectPage />,
            roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
          },
        ],
      },
    ],
  },
  // {
  //   path: "/ipms",
  //   element: (
  //     <ManageIPMSProvider>
  //       <IPMSLayout />
  //     </ManageIPMSProvider>
  //   ),
  //   roles: [
  //     USERROLEENUM.ADMIN,
  //     USERROLEENUM.EMPLOYEE,
  //     USERROLEENUM.FINANCE,
  //     USERROLEENUM.HR,
  //     USERROLEENUM.MANAGER,
  //     USERROLEENUM.TSApprover,
  //   ],
  //   children: [
  //     {
  //       path: "",
  //       element: <HomePage />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //     {
  //       path: "manageGoals",
  //       element: <Outlet />,
  //       roles: [USERROLEENUM.ADMIN],
  //       children: [
  //         {
  //           path: "",
  //           element: <MangageGoalsPage />,
  //           roles: [USERROLEENUM.ADMIN],
  //         },
  //         {
  //           path: "create",
  //           element: <CreateUpdateGoalsForm formType="create" />,
  //           roles: [USERROLEENUM.ADMIN],
  //         },
  //         {
  //           path: "update",
  //           element: <CreateUpdateGoalsForm formType="update" />,
  //           roles: [USERROLEENUM.ADMIN],
  //         },
  //       ],
  //     },
  //     {
  //       path: "employees_list",
  //       element: <Outlet />,
  //       roles: [USERROLEENUM.ADMIN],
  //       children: [
  //         {
  //           path: "",
  //           element: <AppriserEmployeeListPage />,
  //           roles: [USERROLEENUM.ADMIN],
  //         },
  //         {
  //           path: "assign_manager",
  //           element: <AssignManagerForm />,
  //           roles: [USERROLEENUM.ADMIN],
  //         },
  //       ],
  //     },
  //     {
  //       path: "employeegoals",
  //       element: <EmployeeGoalReviewPage />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //     {
  //       path: "employeeGoalAssessment",
  //       element: <EmployeeGoalAssessmentReviewPage />,
  //       roles: [USERROLEENUM.ADMIN, USERROLEENUM.MANAGER, USERROLEENUM.HR, USERROLEENUM.FINANCE],
  //     },
  //     {
  //       path: "ipmsreport",
  //       element: <IPMSReportPage />,
  //       roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
  //     },
  //     {
  //       path: "employeeFinalGoalAssessment",
  //       element: <EmployeeFinalGoalAssessmentReviewPage />,
  //       roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
  //     },
  //     {
  //       path: "goalassessment",
  //       element: <GoalsAssessmentPage />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //     {
  //       path: "goal",
  //       element: <GoalPage />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //     {
  //       path: "guidelines",
  //       element: <GuidelineScreen />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //     {
  //       path: "flowcharts",
  //       element: <FlowCharts />,
  //       roles: [
  //         USERROLEENUM.ADMIN,
  //         USERROLEENUM.HR,
  //         USERROLEENUM.EMPLOYEE,
  //         USERROLEENUM.TSApprover,
  //         USERROLEENUM.MANAGER,
  //         USERROLEENUM.FINANCE,
  //       ],
  //     },
  //   ],
  // },
  // ──────────────────────────────────────────────
  // IPMS NEW (new API routes for testing)
  // ──────────────────────────────────────────────
  {
    path: "/ipms_new",
    element: (
      <NewManageIPMSProvider>
        <IPMSNewLayout />
      </NewManageIPMSProvider>
    ),
    roles: [
      USERROLEENUM.ADMIN,
      USERROLEENUM.EMPLOYEE,
      USERROLEENUM.FINANCE,
      USERROLEENUM.HR,
      USERROLEENUM.MANAGER,
      USERROLEENUM.TSApprover,
    ],
    children: [
      {
        path: "",
        element: <NewHomePage />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.MANAGER,
          USERROLEENUM.TSApprover,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "manageGoals",
        element: <Outlet />,
        roles: [USERROLEENUM.ADMIN],
        children: [
          {
            path: "",
            element: <NewMangageGoalsPage />,
            roles: [USERROLEENUM.ADMIN],
          },
          {
            path: "create",
            element: <NewCreateUpdateGoalsForm formType="create" />,
            roles: [USERROLEENUM.ADMIN],
          },
          {
            path: "update",
            element: <NewCreateUpdateGoalsForm formType="update" />,
            roles: [USERROLEENUM.ADMIN],
          },
        ],
      },
      {
        path: "employees_list",
        element: <Outlet />,
        roles: [USERROLEENUM.ADMIN],
        children: [
          {
            path: "",
            element: <NewAppriserEmployeeListPage />,
            roles: [USERROLEENUM.ADMIN],
          },
          {
            path: "assign_manager",
            element: <NewAssignManagerForm />,
            roles: [USERROLEENUM.ADMIN],
          },
        ],
      },
      {
        path: "employeegoals",
        element: <NewEmployeeGoalReviewPage />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "employeeGoalAssessment",
        element: <NewEmployeeGoalAssessmentReviewPage />,
        roles: [USERROLEENUM.ADMIN, USERROLEENUM.MANAGER, USERROLEENUM.HR, USERROLEENUM.FINANCE],
      },
      {
        path: "ipmsreport",
        element: <NewIPMSReportPage />,
        roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR, USERROLEENUM.MANAGER],
      },
      {
        path: "employeeFinalGoalAssessment",
        element: <NewEmployeeFinalGoalAssessmentReviewPage />,
        roles: [USERROLEENUM.ADMIN, USERROLEENUM.HR],
      },
      {
        path: "goalassessment",
        element: <NewGoalsAssessmentPage />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "goal",
        element: <NewGoalPage />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "guidelines",
        element: <GuidelineScreen />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
      },
      {
        path: "flowcharts",
        element: <FlowCharts />,
        roles: [
          USERROLEENUM.ADMIN,
          USERROLEENUM.HR,
          USERROLEENUM.EMPLOYEE,
          USERROLEENUM.TSApprover,
          USERROLEENUM.MANAGER,
          USERROLEENUM.FINANCE,
        ],
      },
    ],
  },
];
